import { css } from '@emotion/react';

import { colors } from 'src/styles/colors';
import { ZeeFontRegular } from 'src/styles/font';

export const tableContainerStyle = css`
  max-height: 50vh;
  overflow: scroll;
  width: 100%;
  margin: 20px auto;
  border-radius: 8px;
`;

export const tableStyle = css`
  width: 100%;
  padding: 0px 16px;
  border-collapse: collapse;
  border-collapse: separate;
  border-spacing: 0px 4px;
  width: 100%;
`;

export const tableHeaderStyle = css`
  text-align: left;
  padding: 8px 16px;
`;

export const headerCellStyle = css`
  padding: 12px 16px;
  color: ${colors.greyNeutral};
  height: 18px;
  ${ZeeFontRegular(12, 18)}
  :nth-child(3) {
    text-align: right;
  }
`;

export const tableBodyStyle = css`
  background: rgba(255, 255, 255, 0.08);
`;

export const tableRowStyle = css`
  border-radius: 6px;
`;

export const tableCellStyle = css`
  padding: 12px 16px;
  align-items: center;
  color: ${colors.LightGray};
  ${ZeeFontRegular(11, 11)};
`;

export const locationStyle = css`
  display: flex;
  justify-content: flex-end;
  gap: 4px;
  text-transform: uppercase;
  ${ZeeFontRegular(12, 18)};
  color: ${colors.SecondaryNeutral10};
`;

export const iconStyle = css`
  font-size: 14px;
  color: #888;
`;
